import _ from "lodash";
import * as React from "react";

import {
  SignupForm,
  SignupNavigationConfig,
} from "@brexhq/next/sanity-typegen";
import useLocation from "@brexhq/next/src/hooks/useLocation";
import { BlockRowItems } from "@brexhq/shared/types/modules/BlockRowsModule/BlockRowItems";

import {
  LeadBrexSolution,
  LeadContentTag,
  LeadBrexFeature,
  LeadContentType,
  LeadPageSegment,
} from "../../../../types/brex-api";
import { useSSUPrefillContext } from "../../../pageTemplates/SignupPage/utils/SSUPrefillContext";
import {
  PartnerRefValues,
  usePartnerPrefillFromSearchParams,
  UserPrefillData,
} from "../../../routes/signup/Form";

import { LeadFormController } from "./LeadformController";
import {
  LEAD_FORM_PROGRAM_NAME_NO_CHILIPIPER,
  FormType,
  HiddenFields,
} from "./sharedTypes";

export type LeadFormBuildingBlockProps = SignupForm & {
  navigationConfig?: SignupNavigationConfig;
  formExtra?: { textRows: BlockRowItems };
  formType?: FormType;
  userPrefillData?: UserPrefillData;
  partnerRef?: PartnerRefValues | null;
  hiddenFields?: HiddenFields;
  isInlineEmail?: boolean;
};

export const LeadFormBuildingBlock = (props: {
  data: LeadFormBuildingBlockProps;
}) => {
  const { data } = props;
  const {
    userPrefillData: userPrefillDataFromProps,
    partnerRef: partnerRefFromProps,
  } = data;
  const { search } = useLocation();
  const {
    partnerRef: partnerRefFromSearchParams,
    userPrefillData: userPrefillDataFromSearchParams,
  } = usePartnerPrefillFromSearchParams(search);

  const userPrefillData =
    userPrefillDataFromSearchParams ?? userPrefillDataFromProps;

  const partnerRef = partnerRefFromSearchParams ?? partnerRefFromProps;

  const hiddenFields = _.merge(
    {
      contentType: LeadContentType.HIGH_VALUE_FORM,
      contentTag: LeadContentTag.CREATE_ACCOUNT_NO_WAITLIST,
      salesforceCampaign: "EVG | SSU",
      pageSegment: LeadPageSegment.VB_MM_ENT,
      brexSolution: LeadBrexSolution.CARD_AND_CASH,
      brexFeature: LeadBrexFeature.CASH_ACCOUNT,
    },
    data?.hiddenFields,
  );
  const { setPartnerRef, setUserPrefillData } = useSSUPrefillContext();

  React.useEffect(() => {
    setPartnerRef(partnerRef ?? null);
    setUserPrefillData(userPrefillData);
  }, [partnerRef, userPrefillData, setPartnerRef, setUserPrefillData]);

  return (
    <LeadFormController
      data={{
        formType: data?.formType ?? FormType.SALES_LEAD_FORM,
        customProgramName:
          data?.programName ?? LEAD_FORM_PROGRAM_NAME_NO_CHILIPIPER,
        hiddenFields,
        formSettings: {
          backgroundColor: data?.backgroundColor,
          formExtra: data?.formExtra,
          fieldGap: data?.fieldGap,
          disableAnimation: data?.disableAnimation,
          hasBorder: data?.hasBorder,
          hasShadow: data?.hasShadow,
          padding: data?.padding,
          validationEvent: data?.validationEvent,
        },
        isInlineEmail: data?.isInlineEmail ?? false,
        customFormTitle: data?.formTitle,
      }}
      partnerRef={partnerRef}
      userPrefillData={userPrefillData}
      setShowFinalStateView={() => false}
      navigationConfig={data?.navigationConfig}
    />
  );
};
